<template>
  <div>
    <b-row>
      <b-col sm="5">
        <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="40" v-model="funnel.name"
          :markFormDirty="false" />
      </b-col>
      <b-col sm="7">
        <InputText title="Descrição" field="description" :formName="formName" :maxLength="40"
          v-model="funnel.description" :markFormDirty="false" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <CheckboxSimple title="Exibir os valores das locações" v-model="funnel.showValue" />
        <Alert type="info">
          Necessário que o usuário tenha a regra <b>Locação</b>!
        </Alert>
      </b-col>
    </b-row>
    <b-tabs>
      <b-tab title="Permissão">
        <CheckboxSimple title="Compartilhado" v-model="funnel.shared" />
        <div v-if="!funnel.shared">
          <b-row>
            <b-col sm="6">
              <Select title="Usuário(s) com regra Planner" :showNewRegister="false" field="user"
                url="/api/v1/adm/user/select-all-by-rule-name" :propsParams="{ any: 'Planner' }" v-model="selectUser" />
            </b-col>
            <b-col sm="4">
              <div class="btn-add">
                <Button _key="btnAddUser" type="primary" :disabled="!selectUser.id" classIcon="fa-solid fa-plus"
                  size="small" :clicked="addUser" />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <InputTag title="Permitidos" :initialValue="funnel.allowedUsers" v-model="funnel.allowedUsers" />
            </b-col>
          </b-row>
        </div>
      </b-tab>
    </b-tabs>
    <br />
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="saveFunnel" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="saveFunnel" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import InputTag from "@nixweb/nixloc-ui/src/component/forms/InputTag";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple.vue";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import Funnel from "@/components/modules/planner/funnel/Funnel.js";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "funnelCreateUpdate",
  components: {
    Button,
    InputText,
    InputTag,
    Select,
    CheckboxSimple,
    RadioGroup,
    Alert,
  },
  data() {
    return {
      formName: "funnelCreateUpdate",
      funnel: new Funnel(),
      urlCreate: "/api/v1/planner/funnel/create",
      urlUpdate: "/api/v1/planner/funnel/update",
      selectUser: {},
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    ...mapState("user", ["userLogged"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
    ...mapMutations("validation", ["resetValidation"]),
    saveFunnel() {
      this.funnel.userId = this.userLogged.user.id;
      if (this.funnel.id) {
        let params = { url: this.urlUpdate, obj: this.funnel };
        this.putApi(params).then((response) => {
          if (response.success) {
            this.addEvent({ name: "funnelUpdated" });
            this.hideModal();
          }
          this.removeLoading(["saveFunnel"]);
        });
      } else {
        let params = { url: this.urlCreate, obj: this.funnel };
        this.postApi(params).then((response) => {
          if (response.success) {
            this.addEvent({ name: "funnelCreated" });
            this.hideModal();
          }
          this.removeLoading(["saveFunnel"]);
        });
      }
    },
    addUser() {
      if (!this.funnel.allowedUsers.includes(this.selectUser.content)) {
        this.funnel.allowedUsers.push(this.selectUser.content);
        this.selectUser = {};
      }
      this.removeLoading(["btnAddUser"]);
    },
    update(data) {
      this.funnel = new Funnel();
      this.funnel.update(data);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "funnelCreate") {
          this.resetValidation(this.formName);
          this.funnel = new Funnel();
        }
        if (event.name == "funnelUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.btn-add {
  margin-top: 38px;
}
</style>
